module.exports = __webpack_public_path__ + "img/log-2.77a3a800.png";